import {
  getSocNames,
  getAllSocNames,
  getAllSocMouduleNames,
  saveOrUpdateCanvas,
  getSocDataByName,
  saveSocModule,
  updateToVerilogJsonAPI,
  updateSocModule,
  getSocModuleByName,
  deleteSocModuleBySocModuleld,
  // jsonToVerilog,
  getVerilogPathBySocId,
  getVerilogList,
  updateVerilogFile,
  updateVerilogFileName,
  uploadVerilogZip,
  uploadIpxactZip,
  getWidthNumber,
  exec,
  exec2,
  getWaveform,
} from "@/api/soccanvas";
import { getFileContentByPath } from "@/api/public";

const socCanvas = {
  state: {
    socNames: [],
    canvasData: {},
  },

  mutations: {
    SET_SOCNAMES: (state, socNames) => {
      state.socNames = socNames;
    },
    SET_CANVASDATA: (state, canvasData) => {
      state.canvasData = canvasData;
    },
  },

  actions: {
    // 获取soc名称列表
    getAllSocNames({ commit }, limit) {
      return new Promise((resolve, reject) => {
        getAllSocNames(limit)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 获取soc lib名称列表
    getAllSocMouduleNames({ commit }, limit) {
      return new Promise((resolve, reject) => {
        getAllSocMouduleNames(limit)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取soc名称列表
    getSocNames({ commit }) {
      return new Promise((resolve, reject) => {
        getSocNames()
          .then((res) => {
            // commit("SET_SOCNAMES", res.data);
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 根据画布名称获取画布内容
    getSocDataByName({ commit }, name) {
      return new Promise((resolve, reject) => {
        getSocDataByName(name)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 新建或保存画布
    saveOrUpdateCanvas({ commit }, canvasData) {
      return new Promise((resolve, reject) => {
        saveOrUpdateCanvas(canvasData)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // update
    updateSocModule({ commit }, canvasData) {
      return new Promise((resolve, reject) => {
        updateSocModule(canvasData)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 保存元件组
    saveSocModule({ commit }, soucModule) {
      return new Promise((resolve, reject) => {
        saveSocModule({ socModuleJson: soucModule })
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    updateToVerilogJsonAPI({ commit }, data) {
      return new Promise((resolve, reject) => {
        updateToVerilogJsonAPI(data)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取元件集合
    getSocModuleByName({ commit }) {
      return new Promise((resolve, reject) => {
        getSocModuleByName()
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 根据元件组ID进行删除
    deleteSocModuleBySocModuleld({ commit }, id) {
      return new Promise((resolve, reject) => {
        deleteSocModuleBySocModuleld(id)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // get verilog file path
    getVerilogPathBySocId({ commit }, { toVerilogJson, socCanvasId, socName }) {
      return new Promise((resolve, reject) => {
        getVerilogPathBySocId({ toVerilogJson, socCanvasId, socName })
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // get verilog by file path
    getVerilogByPath({ commit }, socVerilogPath) {
      return new Promise((resolve, reject) => {
        getFileContentByPath(socVerilogPath)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // get verilog files list
    getVerilogList({ commit }, socName) {
      return new Promise((resolve, reject) => {
        getVerilogList({ socName })
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // update verilog file by path
    updateVerilogFile({ commit }, { verilogFile, socVerilogPath }) {
      return new Promise((resolve, reject) => {
        updateVerilogFile({ verilogFile, socVerilogPath })
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // update verilog file by path
    updateVerilogFileName(
      { commit },
      { verilogName, socName, socVerilogPath }
    ) {
      return new Promise((resolve, reject) => {
        updateVerilogFileName({
          verilogName,
          socName,
          socVerilogPath,
        })
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // toVerilog
    // jsonToVerilog({ commit }, toVerilogJson) {
    //   return new Promise((resolve, reject) => {
    //     jsonToVerilog({ toVerilogJson: toVerilogJson })
    //       .then((res) => {
    //         resolve(res);
    //       })
    //       .catch((error) => {
    //         reject(error);
    //       });
    //   });
    // },

    // upload veriolog.zip
    uploadVerilogZip({ commit }, formData) {
      return new Promise((resolve, reject) => {
        uploadVerilogZip(formData)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // upload ipxact.zip
    uploadIpxactZip({ commit }, formData) {
      return new Promise((resolve, reject) => {
        uploadIpxactZip(formData)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // trans ports width params to number
    getWidthNumber({ commit }, parameterJson) {
      return new Promise((resolve, reject) => {
        getWidthNumber({ parameterJson: parameterJson })
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    exec({ commit }) {
      return new Promise((resolve, reject) => {
        exec()
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    exec2({ commit }) {
      return new Promise((resolve, reject) => {
        exec2()
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getWaveform({ commit }, data) {
      return new Promise((resolve, reject) => {
        getWaveform(data)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};

export default socCanvas;
